import React from 'react'

const Filter = props => (
  <svg
    width='26'
    height='26'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <defs>
      <path
        d='M21.167 6.167a.833.833 0 0 0 0-1.667H12a.833.833 0 1 0 0 1.667h9.167zm-15.834 0a.833.833 0 0 0 0-1.667h-2.5a.833.833 0 1 0 0 1.667h2.5zM4.5 2.833v5c0 .46.373.834.833.834h3.334c.46 0 .833-.373.833-.834v-5A.833.833 0 0 0 8.667 2H5.333a.833.833 0 0 0-.833.833zm4.167.834l-.834-.834v5L8.667 7H5.333l.834.833v-5l-.834.834h3.334zm12.5 9.166a.833.833 0 1 0 0-1.666h-.834a.833.833 0 1 0 0 1.666h.834zm-7.5 0a.833.833 0 1 0 0-1.666H2.833a.833.833 0 1 0 0 1.666h10.834zM12.833 9.5v5c0 .46.373.833.834.833H17c.46 0 .833-.373.833-.833v-5A.833.833 0 0 0 17 8.667h-3.333a.833.833 0 0 0-.834.833zm4.167.833l-.833-.833v5l.833-.833h-3.333l.833.833v-5l-.833.833H17zm4.167 9.167a.833.833 0 1 0 0-1.667H12a.833.833 0 0 0 0 1.667h9.167zm-15.834 0a.833.833 0 1 0 0-1.667h-2.5a.833.833 0 0 0 0 1.667h2.5zM4.5 16.167v5c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.834H5.333a.833.833 0 0 0-.833.834zM8.667 17l-.834-.833v5l.834-.834H5.333l.834.834v-5L5.333 17h3.334z'
        id='filterA'
      />
    </defs>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <path d='M0 0h24v24H0z' />
      <mask id='filterB' fill='#fff'>
        <use xlinkHref='#filterA' />
      </mask>
      <path
        d='M0 0h100v40H0z'
        mask='url(#filterB)'
        fill='#2D3030'
        id='filters'
      />
    </g>
  </svg>
)

export default Filter



// WEBPACK FOOTER //
// ./src/svg-icons/Filter.js